import { LogoWhiteImage, OptionsLookupIcon } from "assets";
import classNames from "classnames";
import { links } from "data";
import { useAccordionContext } from "domain/accordion/context";
import { WRAPPER_ACCORDION_KEY, WrapperAccordion } from "./components";
import styles from "./mobile-header.module.scss";

export const MobileHeader = () => {
  const { getControls } = useAccordionContext();

  const { switch: switchWrapperAccordion } = getControls(WRAPPER_ACCORDION_KEY);

  return (
    <>
      <div className={styles.container}>
        <header>
          <div className={classNames(styles.content, "container-fluid")}>
            <a href={links.HOMEPAGE}>
              <LogoWhiteImage
                className={styles.logo}
                title="CitySprint header logo"
              />
            </a>

            <OptionsLookupIcon onClick={switchWrapperAccordion} />
          </div>
        </header>
      </div>
      <WrapperAccordion />
    </>
  );
};
